import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6956242"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "videos-page" }
const _hoisted_2 = { class: "ws_common_operation ws_pr20 ws_pt20" }
const _hoisted_3 = { class: "list ws_common_table" }
const _hoisted_4 = {
  key: 1,
  class: "video-list"
}

import { onMounted, ref } from 'vue'
import { queryVideoPage, deleteVideoInfo } from '@/api'
import { PAGE_SIZES, CODE_ENUM } from '@/common'
import { ElMessage } from 'element-plus'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import { useRouter } from 'vue-router'
import i18n from '@/i18n'
import OperationButtonList from '@/components/operation-button-list'
import VideoForm from './components/video-form-drawer.vue'
import SingleVideo from './components/single-video.vue'
import { msgbox } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const router = useRouter()

const advancedRef = ref()

const TYPE_ENUM = {
  TABLE: 'TABLE',
  CARD: 'CARD',
}
const showType = ref(TYPE_ENUM.TABLE)
const changeShowType = (newType: any) => {
  console.log(newType, 'newTypenewType')
  showType.value = newType
}

const buttonList = ref([
  {
    type: 'edit',
    text: t('D_INFO.btnEdit'),
  },
  {
    type: 'delete',
    text: t('D_INFO.btnDelete'),
  },
])

const columns = [
  {
    prop: 'name',
    label: t('STATISTICS.vname'),
  },
  {
    prop: 'typeStr',
    label: t('STATISTICS.vType'),
  },
  {
    prop: 'protocolPals',
    label: t('STATISTICS.vprotocolPals'),
  },
  {
    prop: 'address',
    label: t('STATISTICS.vaddress'),
  },
  {
    prop: 'number',
    label: t('STATISTICS.vnumber'),
  },
]

const tableData: any = ref([])
const formInline = ref({
  name: '',
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const tableLoading = ref(false)

const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData()
  const { data, reset } = queryData || {}

  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true

  const res: any = await queryVideoPage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}
onMounted(() => {
  fetchList()
})

const formConf = ref({
  visible: false,
  data: {},
})
const toForm = (data: any) => {
  formConf.value = {
    visible: true,
    data,
  }
}

const toDelete = (row: any) => {
  msgbox({
    tip: t('STATISTICS.vdelTip'),
    thenFn: () => handleDelete(row),
  })
}

const handleDelete = async ({ id }: any) => {
  const res: any = await deleteVideoInfo({ id })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AdvancedQueryLayout), {
        ref_key: "advancedRef",
        ref: advancedRef,
        model: formInline.value,
        onFetchList: fetchList,
        "label-width": 92,
        border: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('STATISTICS.vname'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.name) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        (showType.value === TYPE_ENUM.CARD)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              plain: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeShowType(TYPE_ENUM.TABLE)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.vtypeTable')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              plain: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changeShowType(TYPE_ENUM.CARD)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.vtypeCard')), 1)
              ]),
              _: 1
            })),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: toForm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.videoNew')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (showType.value === TYPE_ENUM.TABLE)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: tableData.value,
              stripe: "",
              class: "ws_mt20 device-table"
            }, {
              empty: _withCtx(() => [
                _createVNode(_component_el_empty, {
                  description: _ctx.$t('D_INFO.noData')
                }, null, 8, ["description"])
              ]),
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
                  return _createVNode(_component_el_table_column, _mergeProps({
                    key: item.prop
                  }, {
            ...item,
          }, { "show-overflow-tooltip": "" }), null, 16)
                }), 64)),
                _createVNode(_component_el_table_column, {
                  prop: "operation",
                  label: _ctx.$t('D_INFO.colOperation'),
                  width: "280"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_unref(OperationButtonList), {
                      buttonList: buttonList.value,
                      scope: scope.row,
                      onOnEdit: toForm,
                      onOnDelete: toDelete
                    }, null, 8, ["buttonList", "scope"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, tableLoading.value]
            ])
          : _createCommentVNode("", true),
        (showType.value === TYPE_ENUM.CARD)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item) => {
                return (_openBlock(), _createBlock(SingleVideo, _mergeProps({
                  key: item.id
                }, { ...item }, {
                  id: item.id
                }), null, 16, ["id"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _createVNode(VideoForm, {
      visible: formConf.value.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((formConf.value.visible) = $event)),
      data: formConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})